// base path should be / or any folder path where its hosted

// export const base_path ='/react/template/'
export const base_path ='/'
export const img_path ='/'
export const img_api ='https://liftback.net.pe:8080/api/file/images/'
export const API_BASE_URL ='https://liftback.net.pe:8080/api/'
// export const API_BASE_URL ='http://localhost:8080/api/'
// export const base_path ='/'
